<template>
    <div class="alert alert-danger alert-dismissible fade show error-component" role="alert">
        {{message}}
        <slot></slot>
    </div>
</template>

<script>
    export default {
        mounted() {
        },
        props: ['message']
    };
</script>
